import React from 'react';
import moment from 'moment';

export default props => {
	const marksByMonth = {};
	props.tally.marks && props.tally.marks.forEach(mark => {
		const key = mark.datetime.substring(0, 7);
		marksByMonth[key] = marksByMonth[key] || [];
		marksByMonth[key].push(mark);
	});

	return (
		<div className="TALLY">
			<div className="heading">
				<span className="count">{props.tally.marks ? props.tally.marks.length : '0'}</span>
				<span className="name">{props.tally.name}</span>
				<ul className="actions">
					<li><label htmlFor="panel-set">BACK</label></li>			
					<li><span onClick={() => props.handleSelectModal('EDIT-TALLY', { name: props.tally.name })}>RENAME</span></li>
					<li><span onClick={() => props.handleSelectModal('DELETE-TALLY', { name: props.tally.name })}>DELETE</span></li>
					<li><span onClick={() => props.handleSelectModal('MOVE-TALLY', { name: props.tally.name })}>MOVE</span></li>
				</ul>
			</div>

			<div className="primary-action">
				<button className="button alt-add-mark" onClick={() => props.handleSelectModal('ADD-MARK')}>Add Mark</button>
			</div>

			{Object.keys(marksByMonth).map(month => (
				<div key={month} className="month">
					<div className="month-heading">{moment(month).format('MMMM YYYY')}</div>
					<ul className="marks">
						{marksByMonth[month].reverse().map(mark => (
							<li key={mark.id} className={`${mark.comment && 'comment'}`} onClick={() => (
								props.handleSelectModal('EDIT-MARK', {
									mark: mark.id,
									datetime: mark.datetime,
									comment: mark.comment
								})
							)}>
								<span className="date">{moment(mark.datetime).format('D')}</span>
							</li>
						))}
					</ul>
				</div>
			))}
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/components/tally-panel.js